import React from 'react';
import { Helmet } from 'react-helmet';

const GenericHelmet = ({
  title,
  description,
  image,
  url,
  regionName,
  twitterCard = 'summary_large_image',
  favicon = 'https://res.cloudinary.com/joegalaxy/image/upload/v1656195322/Images/favicon_urfztm.ico',
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="icon" type="image/png" href={favicon} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {image && <meta property="og:image" content={image} />}
    <meta property="og:type" content="website" />
    {url && <meta property="og:url" content={url} />}
    <meta name="twitter:card" content={twitterCard} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    {image && <meta name="twitter:image" content={image} />}
    {regionName && <meta name="region" content={regionName} />}
  </Helmet>
);

export default GenericHelmet;
